<div class="dialog-container">
  <div *ngIf="loading" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div>
  <div class="form-header">
    <div>History</div>
    <div class="load-status" *ngIf="loading">{{getLoadedSize()}} of {{itemList.length}}</div>
  </div>
  <div class="graph-container" cdkDropList  (cdkDropListDropped)="dropItem($event)" *ngIf="multi && !loading">
    <div *ngFor="let item of getGraphableItems()" cdkDrag class="graph-box">
      <div class="item-title">{{item.name}}</div>
      <div class="graph-holder" *ngIf="multi && multi.has(item.id)" >
        <chart class="chart-dims"[type]="type" [data]="multi.get(item.id)" [options]="options" [plugins]="plugins"></chart>
      </div>
      <div class="summary" *ngIf="statistics.has(item.id)">
        <div class="summary-row">
          <div class="summary-name">Average:</div>
          <div class="summary-value">{{statistics.get(item.id).average | number:'1.1-2'}}</div>
        </div>
        <div class="summary-row">
          <div class="summary-name">Count:</div>
          <div class="summary-value">{{statistics.get(item.id).count}}</div>
        </div>
        <div class="summary-row">
          <div class="summary-name">Maximum:</div>
          <div class="summary-value">{{statistics.get(item.id).maximum | number:'1.1-2'}}</div>
        </div>
        <div class="summary-row">
          <div class="summary-name">Minimum:</div>
          <div class="summary-value">{{statistics.get(item.id).minimum | number:'1.1-2'}}</div>
        </div>
      </div>
    </div>  
    <div *ngFor="let key of getSymptomGroupsKeys()" cdkDrag class="graph-box">
      <div class="item-title">How {{patientName}} Feels - {{symptomGroups.get(key).compassName}}</div>
      
      <div class="graph-holder">
        <chart class="chart-dims"[type]="'line'" [data]="getSymptomData(key)" [options]="stackedOptions" [plugins]="plugins"></chart>
      </div>

    </div>


  </div>
   